import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const PHASES = [
  {
    id: 'oct-popups-2026',
    expires: new Date('2026-10-23T18:00:00'),
    badge: 'October Pop-Ups',
    title: <>Two Nights.<br />Big Air.</>,
    halloween: false,
    lines: [
      'Adult Trapeze Pop-up — Thu, Oct 23 · 6:30pm',
      '🎃 Bungee Halloween Glow Party — Fri, Oct 30 · 5:30 & 7:00pm',
    ],
  },
  {
    id: 'glow-party-2026',
    expires: new Date('2026-10-30T19:00:00'),
    badge: 'One Night · Two Sessions',
    title: <>🎃 Bungee Halloween<br />Glow Party</>,
    halloween: true,
    lines: [
      'Fri, Oct 30 · 5:30 & 7:00pm — fly in the glow.',
    ],
  },
];

const HIDDEN_PATHS = ['/aerial', '/book-event', '/admin'];

const EventsPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const phase = PHASES.find(p => new Date() < p.expires);

  useEffect(() => {
    if (!phase) return;
    if (sessionStorage.getItem(`gcf-events-popup-${phase.id}`)) return;
    const timer = setTimeout(() => setIsOpen(true), 1500);
    return () => clearTimeout(timer);
  }, [phase]);

  if (!phase || !isOpen) return null;
  if (HIDDEN_PATHS.some(p => location.pathname.startsWith(p))) return null;

  const handleClose = () => {
    sessionStorage.setItem(`gcf-events-popup-${phase.id}`, 'true');
    setIsOpen(false);
  };

  return (
    <div className="camp-popup-overlay" onClick={handleClose} data-testid="events-popup-overlay">
      <div className={`camp-popup ${phase.halloween ? 'halloween' : ''}`} onClick={(e) => e.stopPropagation()} data-testid="events-popup">
        <button className="camp-popup-close" onClick={handleClose} aria-label="Close announcement" data-testid="events-popup-close">
          <X size={18} />
        </button>
        <div className="camp-popup-badge"><Sparkles size={14} /> {phase.badge}</div>
        <h3 className="camp-popup-title">{phase.title}</h3>
        <div className="camp-popup-weeks">
          {phase.lines.map((line) => (
            <span className="camp-popup-week" key={line}>{line}</span>
          ))}
        </div>
        <Link to="/book-event" onClick={handleClose}>
          <Button className="camp-popup-cta" data-testid="events-popup-book-btn">
            Grab Your Spot →
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default EventsPopup;
